import * as yup from "yup";

const sampleTemplateSchema = yup.object({
  first_name: yup.string().required("First Name is required"),
  last_name: yup.string().required("Last Name is required"),
  email: yup.string().email().required(),
  password: yup.string().required(),
  age: yup.number().positive().integer().required(),
});

export default sampleTemplateSchema;
